import { Button } from "@/components/ui/button";
import { cn } from "@/utils/cn";

interface NavCtaProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "secondary" | "primary";
}

/** Styled CTA button for navbars — "Get Started", "Login", etc. */
export const NavCta: React.FC<NavCtaProps> = ({
  variant = "primary",
  className,
  children,
  ...rest
}) => {
  return (
    <Button
      variant={variant == "primary" ? "accent" : "outline"}
      className={cn("text-sm font-medium", className)}
      {...rest}
    >
      {children}
    </Button>
  );
};
